import { render } from "./AggiungiFattura.vue?vue&type=template&id=bae5ec96&scoped=true"
import script from "./AggiungiFattura.vue?vue&type=script&lang=js"
export * from "./AggiungiFattura.vue?vue&type=script&lang=js"

import "./AggiungiFattura.vue?vue&type=style&index=0&id=bae5ec96&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bae5ec96"]])

export default __exports__